import { render, staticRenderFns } from "./sky-input-extent.vue?vue&type=template&id=6b395976"
import script from "./sky-input-extent.vue?vue&type=script&lang=js"
export * from "./sky-input-extent.vue?vue&type=script&lang=js"
import style0 from "./sky-input-extent.vue?vue&type=style&index=0&id=6b395976&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports